//@flow
import type { Saga } from "redux-saga";
import { all } from "redux-saga/effects";
import { notificationsSagas } from "../notifications";

export function* rootSaga(): Saga {
  yield all(notificationsSagas);
}
